module.exports = __webpack_public_path__ + "static/hero-car-loan-a7b62a3821d6628e5b8422e7f40d97af.webp";